<template lang="html">
  <div class="placed-backg contact-page-" id="page-info-t1">
    <div class="bg-image"></div>

    <section class="container oversized-container content-section">
      <div class="row align-items-center justify-content-center">
        <div class="col-lg-5 text-center col-info">
          <h1 class="mb-2 page-title">Contacto</h1>

          <!-- <p>
            Nos gustaría llevarte nuestro muestrario, regalarte un catálogo y platicarte sobre nuestros atractivos precios de mayoreo en persona.
          </p> -->
          <p class="mt-2">
            Escríbenos o llámanos para programar una cita o llamada.
          </p>

          <hr />
          <h5 class="subtitle-sm">Matriz:</h5>
          <p>
            Dr. Arturo Guerra No. 361,<br />
            Col. Braulio Maldonado, C.P. 21480,<br />
            Tecate, Baja California.
          </p>

          <br />
          <h5 class="subtitle-sm">Teléfono:</h5>
          <p>
            <strong class="f-w-600">Matriz:</strong> (665) 654 0484<br />
            <strong class="f-w-600">Tijuana:</strong> (664) 687 8023<br />
            <strong class="f-w-600">Call Center:</strong> (663) 203 1001<br />
          </p>

          <br />
          <h5 class="subtitle-sm">Correo  Electrónico:</h5>
          <p>
            <a class="f-w-600 txt-black" href="mailto:servicioacliente@mfdoit.com.mx">servicioacliente@mfdoit.com.mx</a>
          </p>
        </div>

        <div class="col-lg-5 col-xl-4 col-info">
          <b-form @submit="onSubmit">
            <b-form-group>
              <b-form-input
                v-model="form.name"
                type="text"
                placeholder="Nombre"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-input
                v-model="form.email"
                type="email"
                placeholder="Correo electrónico"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-input
                v-model="form.phone"
                type="text"
                placeholder="Teléfono"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-textarea
                v-model="form.msg"
                placeholder="Mensaje"
                rows="3"
                max-rows="6"
                required
              ></b-form-textarea>
            </b-form-group>

            <p class="text-center">
              <b-button type="submit" class="btn-send">ENVIAR</b-button>
            </p>
          </b-form>

        </div>
      </div>
      <sweet-modal ref="modalAlert" :icon="modal.icon" :block="modal.block">
        <div class="fa-3x" v-if="modal.block"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div v-html="modal.msg"></div>
      </sweet-modal>
    </section>

    <section class="container-fluid px-0 map-section">
      <GmapMap
        :center="center"
        :zoom="12.30"
        map-type-id="terrain">
        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          @click="openMap(index)"
        />
      </GmapMap>
      <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d916.7464454515701!2d-116.6314075750742!3d32.56243268389028!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d91294afb8e11b%3A0xaae3e9f7a577d99b!2sMaderas%20y%20Ferreter%C3%ADas%20DUR%C3%81N!5e0!3m2!1ses!2smx!4v1644359592257!5m2!1ses!2smx" allowfullscreen="" loading="lazy"></iframe> -->
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        name: null,
        email: null,
        phone: null,
        msg: null
      },

      center: { lat: 32.5360064, lng: -116.7948014 },
      markers: [
        { mapURL: 'https://goo.gl/maps/ZNSS3oAeyQ7UFRyM9', position: { lat: 32.5627341, lng: -116.6334279 } },
        { mapURL: 'https://goo.gl/maps/npWDiXZ2MVc2xtoS6', position: { lat: 32.558884, lng: -116.6583805 } },
        { mapURL: 'https://goo.gl/maps/LyFYgBfNJZHwhZ6T7', position: { lat: 32.5652625, lng: -116.615016 } },
        { mapURL: 'https://goo.gl/maps/vUBqV5eqvRReWTjL8', position: { lat: 32.4983278, lng: -116.9573054 } },
        { mapURL: 'https://goo.gl/maps/vD74VzJcZHpf29hT9', position: { lat: 32.5435724, lng: -116.9433456 } },
        { mapURL: 'https://goo.gl/maps/Ni9BhPEVdm18bAT56', position: { lat: 32.5124022, lng: -116.895329 } },
      ],

      info: [],
      modal:{
        icon:null,
        msg:null,
        block:null,
      }
    }
  },

  methods: {
    openMap(idx){
      window.open(this.markers[idx].mapURL, '_blank').focus();
    },

    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      })
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.modal.icon = null;
      this.modal.msg = 'Enviando información';
      this.modal.block = true;
      this.$refs.modalAlert.open();

      //var data=tools.params(form, this.form);
      axios.post(tools.url("/api/contact"), this.form).then((response)=>{
          this.makeToast('default', response.data.response, 'Mensaje enviado');
          this.form = {
            name: null,
            email: null,
            msg: null,
            check: null
          };

          this.modal.icon = 'success';
          this.modal.msg = 'Información enviada correctamente';
          this.modal.block = false;
          

        }).catch( (error)=> {
        // console.log(error.response);
        let errors = error.response.data;
        // console.log(errors);
        this.makeToast('danger', error.response.data.name, 'Error');
        this.makeToast('danger', error.response.data.email, 'Error');
        this.makeToast('danger', error.response.data.phone, 'Error');
        this.makeToast('danger', error.response.data.msg, 'Error');

          this.modal.icon = 'error';
          this.modal.msg = 'Ocurrio un error al guardar la información';
          this.modal.block = false;
      });
    }
  },

  beforeMount(){
    if(this.$route.query.p){
      this.form.msg = 'Me intresa el producto '+ this.$route.query.p;
    }
  }
}
</script>
